/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ code: NonNullable<unknown> }} Pxk_Sp_Scan_MatchInputs */

const vi_pxk_sp_scan_match = /** @type {(inputs: Pxk_Sp_Scan_MatchInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Khớp lô ${i?.code}`)
};

/**

* @param {Pxk_Sp_Scan_MatchInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pxk_sp_scan_match = /** @type {((inputs: Pxk_Sp_Scan_MatchInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pxk_Sp_Scan_MatchInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pxk_sp_scan_match(inputs)
});